import { Dialog, DialogPanel, DialogTitle, DialogBackdrop } from '@headlessui/react';

type ModalProps = {
  title?: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

export const Modal = ({ title, isOpen, onClose, children }: ModalProps) => {
  return (
    <Dialog
      open={isOpen}
      as="div"
      className="relative z-50 focus:outline-none bg-black"
      onClose={onClose}>
      <DialogBackdrop className="fixed inset-0 bg-black/40" />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4">
          <DialogPanel
            transition
            className="w-full shadow-lg max-w-2xl rounded-xl bg-white p-6 backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0">
            {title && (
              <DialogTitle as="h3" className="text-base/7 font-bold text-black">
                {title}
              </DialogTitle>
            )}
            <div>{children}</div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};
